import { styled } from '@mui/material/styles';

export const Description = styled('div')(({ theme }) => ({
  '&&': {
    fontWeight: theme.fontWeight.bold,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1)
  }
}));
